import styled from 'styled-components'

export const PopupOverlayUi = styled.div<{ zIndex: number }>`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: ${p => p.zIndex};
`
